import { connect } from "react-redux";
import LobListing from "./lobListing";
import { bindActionCreators } from "redux";
import {getLobListing} from 'services/redux/Lob/action';

const mapStateToProps = (state) => ({
    lobList: state.lobReducer.lobList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getLobListing
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(LobListing);